export const DELETED_CUSTOMER_QUEUE_STATUS = {
  IN_QUEUE: 0,
  IN_PROGRESS: 1,
  DONE: 2,
  FAILED: 3,
  PARTIALLY_FAILED: 4,
  HEAVY_DATA_RETRY: 5,
} as const;

export type DeletedCustomerQueueStatus =
  (typeof DELETED_CUSTOMER_QUEUE_STATUS)[keyof typeof DELETED_CUSTOMER_QUEUE_STATUS];

export const DELETED_CUSTOMER_STATUSES = [
  {
    id: 'CUSTOMER_DELETION_IS_IN_QUEUE',
    label: 'In queue',
    value: DELETED_CUSTOMER_QUEUE_STATUS.IN_QUEUE,
  },
  {
    id: 'CUSTOMER_DELETION_IS_IN_PROGRESS',
    label: 'In progress',
    value: DELETED_CUSTOMER_QUEUE_STATUS.IN_PROGRESS,
  },
  {
    id: 'CUSTOMER_DELETION_DONE',
    label: 'Done',
    value: DELETED_CUSTOMER_QUEUE_STATUS.DONE,
  },
  {
    id: 'CUSTOMER_DELETION_FAILED',
    label: 'Failed',
    value: DELETED_CUSTOMER_QUEUE_STATUS.FAILED,
  },
  {
    id: 'CUSTOMER_DELETION_PARTIALLY_FAILED',
    label: 'Partially failed',
    value: DELETED_CUSTOMER_QUEUE_STATUS.PARTIALLY_FAILED,
  },
  {
    id: 'CUSTOMER_DELETION_HEAVY_DATA_RETRY',
    label: 'Heavy data retry',
    value: DELETED_CUSTOMER_QUEUE_STATUS.HEAVY_DATA_RETRY,
  },
] as const;
